<template>
  <div class="share-palette clearfix">
    <div class="palette-button share-palette-item" data-cmd="share" data-arg="facebook">
      <div class="share-icon share-icon-facebook"></div>
    </div>
    <div class="palette-button share-palette-item" data-cmd="share" data-arg="twitter">
      <div class="share-icon share-icon-twitter"></div>
    </div>
    <!--<div class="palette-button share-palette-item" data-cmd="share" data-arg="google">-->
      <!--<div class="share-icon share-icon-google"></div>-->
    <!--</div>-->
  </div>
</template>

<style lang="scss" scoped>

  $w: 40px;

  .share-palette {
    width: $w * 1;
  }

  .share-palette-item {
    width: 40px;
    height: 40px;


    .share-icon {
      width: 24px;
      height: 24px;
      margin: 8px;
      background-image: url(../../assets/social_icons.png);

      background-repeat: no-repeat;
      background-size: 48px 24px;

      &.share-icon-twitter {
        background-position: 0 0;
      }

      &.share-icon-facebook {
        background-position: -24px 0;
      }
    }

    &:hover {

      div {
        background-color: #fff;
        &.line-icon-0 {
          height: 1px;
          background: none;
          border-top: 1px dotted #fff;
        }
      }
    }
  }
</style>

<script>
  import state from '../../data/state';

  export default{
    data(){
      return {
        state
      }
    },

  }
</script>



// WEBPACK FOOTER //
// Share.vue?3933ed8f